const TRIAL_PLAN_NAME = 'trial-pro-monthly'

const StorageKeys = {
  enjoyTrialPopup: 'enjoy_trial_popup',
  trialNotAvailablePopup: 'trial_not_available_popup',
}

const sessionKey = (prefix, user) => `${prefix}_${user.id}`

export function isTrialLink(url) {
  if (!url) return false

  return url.includes('code=AHA_21169')
}

export function scheduleShowEnjoyTrialPopup(user) {
  sessionStorage.setItem(sessionKey(StorageKeys.enjoyTrialPopup, user), 'true')
}

export function canShowEnjoyTrialPopup(user) {
  return sessionStorage.getItem(sessionKey(StorageKeys.enjoyTrialPopup, user)) === 'true'
}

export function scheduleShowTrialNotAvailablePopup(user) {
  sessionStorage.setItem(sessionKey(StorageKeys.trialNotAvailablePopup, user), 'true')
}

export function canShowTrialNotAvailablePopup(user) {
  return sessionStorage.getItem(sessionKey(StorageKeys.trialNotAvailablePopup, user)) === 'true'
}

export function clearPopupSessionData(user) {
  sessionStorage.removeItem(sessionKey(StorageKeys.enjoyTrialPopup, user))
  sessionStorage.removeItem(sessionKey(StorageKeys.trialNotAvailablePopup, user))
}

export function isPlanDifferentFromTrial(user) {
  return user && user.plan !== TRIAL_PLAN_NAME
}
